import Grid from '@mui/material/Grid';
import config from '../../app/config';
import makeStyles from '@mui/styles/makeStyles';
import {useDispatch, useSelector} from 'react-redux';
import {FormControl, MenuItem, Select} from '@mui/material';
import {useTranslation} from 'react-i18next';
import React, {useEffect} from 'react';
import {patient as patientPreferences, savePref} from '../../store/reducers/preferences';
import _ from 'lodash';
import Switch from '@mui/material/Switch';
import moment from 'moment';
import Radio from '@mui/material/Radio';
import {hasPermission, isAdmin, user} from '../../store/reducers/user';
import API from '../../app/api';
import ListSubheader from '@mui/material/ListSubheader';
import clsx from 'clsx';
import InputLabel from '@mui/material/InputLabel';

const useStyles = makeStyles((theme) => ({
  modalBody: {
    width: "calc(100vw - 190px)",
    background: "#3D3E40",
    height: "100vh",
    borderLeft: "1px solid black",
    paddingLeft: 40,
    //  paddingTop: 35
  },
  displayImageContainer: {
    marginTop: 30,
    height: "50%",
    overflow: "auto",
  },
  dialogContentStyle: {
    backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#ebebeb",
  },
  dropDown: {
    //   color: "black !important",
    // border: "1px solid grey",
    borderRadius: 8,
    paddingLeft: "5px",
    padding: 2,
    minHeight: "40px",
    width: "85%",
    //paddingLeft: 16,
    // "& MuiSelect-icon": {
    //     color: "black !important"
    // }
  },
  colorBox: {
    padding: 12,
    borderBottom: "1px solid #dcd8d8",
    marginBottom: 10,
    display: "flex",
    alignItems: "center",
  },
  selectorItemFormControl: {
    width: "90%",
  },
  // selectorItemSelect: {
  //     width: "100%",
  //     fontSize: "80%",
  //     marginTop: "9px !important",
  // },
  selectorItemLabel: {
    fontSize: "80%",
  },
  dropDownIcon: {
    //  color: "black !important"
  },
  title: {
    color: "#FFF",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    marginBottom: 25,
    marginTop: 25,
  },
  filterName: {
    margin: "10px 0px",
    fontWeight: 700,
    fontSize: 14,
  },
  singleFilterName: {
    color: "#FFF",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
  },
  tag: {
    background: "#313233",
    color: "#ACAFB3",
    display: "inline-flex",
    height: "24px",
    padding: "4px 6px",
    alignItems: "flex-start",
    fontSize: 12,
    borderRadius: 6,
    marginRight: 5,
  },
  prefName: {
    fontSize: 14,
    marginBottom: 15,
    fontWeight: 500,
  },
  deleteButton: {
    cursor: "pointer",
    borderRadius: 30,
    border: "1px solid #ACAFB3",
    padding: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 90,
    height: 32,
    color: "#ACAFB3",
    fontSize: 12,
    marginTop: 10,

    "&:hover": {
      backgroundColor: "#ACAFB3",
      color: "white",
    },
  },
  colorPair: { marginLeft: "15px", marginRight: "15px" },
  colorLeftWrap: {
    position: "relative",
    display: "inline-block",
    width: "50%"
  },
  colorOne: {
    marginLeft: "15px",
    marginRight: "15px",
    border: '5px solid #929292',
    borderRadius: 5,
    height: 30,
    width: "100%",
    display: 'inline-flex',
  },
  colorLabel: {
    position: "absolute",
    top: "3px",
    left: "45%",
    //color: "#dfdede"
  },
  colorSelectedLabel: {
    position: "absolute",
    top: "12px",
    left: "45%",
    //color: "#dfdede"
  },
  colorLeftBox: {
    width: "100%",
    height: "30px",
    border: "5px solid #929292",
    borderRight: "0",
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px"
  },
  colorRightBox: {
    display: "inline-flex",
    width: "50%",
    height: "30px",
    border: "5px solid #929292",
    borderLeft: "0",
    borderTopRightRadius: "5px",
    borderBottomRightRadius: "5px"
  }
}));

function PreferencesScreen(props) {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const patientPreferencesObject = useSelector(patientPreferences);
  const userObject = useSelector(user);

  let valueThumbnailSize = patientPreferencesObject.thumbnailSize === "big";
  let valueHistoryPosition = patientPreferencesObject.historyBarPosition === "bottom";
  let valueFontSize = patientPreferencesObject.fontSize;
  let valueAnnotationColor = patientPreferencesObject.color;
  let valueHoldingPenViewList = patientPreferencesObject.valueHoldingPenView === "list";
  let valueBulkActionMode = patientPreferencesObject.bulkActionMode === "show";

  const [annotationColor, setAnnotationColor] = React.useState(
    patientPreferencesObject.colorSet,
  );

  let valueFramePreloadMode = patientPreferencesObject.framePreloadMode || "none";

  const [filters, setFilters] = React.useState(
    config.modules.holdingPen.filters,
  );
  const [holdingPenSettings, setHoldingPenSettings] = React.useState(
    config.modules.hasOwnProperty("holdingPen"),
  );
  const [holdingPenDicts, setHoldingPenDicts] = React.useState([]);

  //has own properties Holding pen
  useEffect(() => {
    if (userObject && userObject.permissions) {
      setHoldingPenSettings(
        config.modules.hasOwnProperty("holdingPen") &&
          (dispatch(
            hasPermission(config.modules.holdingPen.accessPermission),
          ) ||
            dispatch(isAdmin())),
      );
    }
  }, [userObject]);

  const prepareDictStruct = (inputData, displayField, groupBy) => {
    if (groupBy) {
      let t = inputData.filter((item) => item.hasOwnProperty(groupBy));
      return Object.groupBy(t, (item) => item[groupBy]);
    } else {
      return _.sortBy(inputData, [displayField]);
    }
  };

  useEffect(() => {
    if (filters) {
      const dictFilters = _.filter(filters, (f) => {
        return (
          f.hasOwnProperty("availableInPreferences") && f.availableInPreferences
        );
      });
      let dictFiltersPromises = [];
      let dictFiltersItems = [];
      let holdingPenFilterDicts = [];
      dictFilters.forEach((df) => {
        if (df.hasOwnProperty("dictUrl")) {
          dictFiltersPromises.push(API.getDictByURL(df.dictUrl));
          dictFiltersItems.push(df);
        }
      });

      Promise.all(dictFiltersPromises).then((dicts) => {
        for (let i = 0; i < dictFiltersItems.length; i++) {
          holdingPenFilterDicts.push({
            filter: _.cloneDeep(dictFiltersItems[i]),
            dict: prepareDictStruct(
              dicts[i].__data,
              dictFiltersItems[i].displayField,
              dictFiltersItems[i].groupByField,
            ),
            __filterValue: patientPreferencesObject?.holding?.defaultFilters
              ? patientPreferencesObject.holding.defaultFilters[
                  dictFiltersItems[i]["_id"]
                ]
              : null,
          });
        }
        setHoldingPenDicts(holdingPenFilterDicts);
      });
    }
  }, [filters]);

  useEffect(() => {
    if (holdingPenDicts.length > 0) {
      let tmpHPDs = _.cloneDeep(holdingPenDicts);
      for (let i = 0; i < tmpHPDs.length; i++) {
        tmpHPDs[i]["__filterValue"] = patientPreferencesObject?.holding
          ?.defaultFilters
          ? patientPreferencesObject.holding.defaultFilters[
              tmpHPDs[i].filter["_id"]
            ]
          : null;
      }
      setHoldingPenDicts(tmpHPDs);
    }
  }, [patientPreferencesObject]);

  const handleChange = () => {
    let data = _.cloneDeep(patientPreferencesObject);
    data.thumbnailSize = data.thumbnailSize === "big" ? "small" : "big";

    dispatch(savePref(data));
  };

  const handleHistoryBarPositionChange = () => {
    let data = _.cloneDeep(patientPreferencesObject);
    data.historyBarPosition =
      data.historyBarPosition === "bottom" ? "top" : "bottom";

    dispatch(savePref(data));
  };

  const handleHoldingPenViewChange = () => {
    let data = _.cloneDeep(patientPreferencesObject);
    data.valueHoldingPenView = data.valueHoldingPenView === "list" ? "single" : "list";

    dispatch(savePref(data));
  };

  const handleBasketViewChange = (event) => {
    let data = _.cloneDeep(patientPreferencesObject);
    data.bulkActionMode = event.target.value;

    dispatch(savePref(data));
  };

  const handleChangeInitOpen = (event) => {
    let data = _.cloneDeep(patientPreferencesObject);
    data.initiallyOpen = event.target.value;

    dispatch(savePref(data));
  };

  const handleChangeFontSize = (event) => {
    let data = _.cloneDeep(patientPreferencesObject);
    data.fontSize = event.target.value;
    dispatch(savePref(data));
  };

  const handleChangeColor = (event) => {
    setAnnotationColor(event.target.value);
    let data = _.cloneDeep(patientPreferencesObject);
    data.colorSet = event.target.value;

    dispatch(savePref(data));
  };

  const handleChangeFramePreloadMode = (event) => {
    let data = _.cloneDeep(patientPreferencesObject);
    data.framePreloadMode = event.target.value;
    dispatch(savePref(data));
  };

  const removeFilter = (index) => {
    let data = _.cloneDeep(patientPreferencesObject);

    let removedItem = data.filtersList[index];
    delete data.filtersList.splice(index, 1);

    if (removedItem.name === data.selectedFilterName) {
      data.selectedFilterName = null;
    }

    data.filters = null;
    data.sortStudy = "date";
    dispatch(savePref(data));
  };

  const mainFilter = (name) => {
    let data = _.cloneDeep(patientPreferencesObject);
    data.selectedFilterName = name;
    dispatch(savePref(data));
  };

  const changeFilterValue = (filterItem, event) => {
    // console.log('changeFilterValue', filterItem, event.target.value, filterItem.dict);
    let data = _.cloneDeep(patientPreferencesObject);
    if (!data.hasOwnProperty("holding")) {
      data.holding = {};
    }
    if (!data.holding.hasOwnProperty("defaultFilters")) {
      data.holding.defaultFilters = {};
    }
    delete data.holding.defaultFilters[filterItem.filter["_id"] + ".grouped"];
    if (filterItem.hasOwnProperty("groupByField") && filterItem.dict) {
      let allItems = [];
      Object.keys(filterItem.dict).forEach((key) => {
        allItems.push(...filterItem.dict[key]);
      });
      const filteredValues = _.filter(
        allItems,
        (i) => i.__id == event.target.value,
      );
      if (filteredValues.length > 0) {
        data.holding.defaultFilters[filterItem.filter["_id"] + ".grouped"] =
          filteredValues[0].parentLocation + " " + filteredValues[0].__id;
      }
    }
    data.holding.defaultFilters[filterItem.filter["_id"]] = event.target.value;
    dispatch(savePref(data));
  };

  const removeFilterValue = (filterItem) => {
    let data = _.cloneDeep(patientPreferencesObject);
    data.holding.defaultFilters[filterItem.filter["_id"]] = null;
    dispatch(savePref(data));
  };

  return (
    <div className={clsx(classes.modalBody, "scroll-normal-white")}>
      <div className={classes.title}>Preferences</div>
      <Grid container>
        <Grid item xs={12} md={2}>
          <div className={classes.prefName}> Thumbnail size: </div>
          <Grid component="label" container alignItems="center" spacing={1}>
            <Grid item>small</Grid>
            <Grid item>
              <Switch
                checked={valueThumbnailSize}
                classes={{ track: classes.prefSwitch }}
                onChange={handleChange}
                color="primary"
              />
            </Grid>
            <Grid item>big</Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={2}>
          <div className={classes.prefName}> Studies initially open: </div>

          <Select
            className={classes.dropDown}
            labelId="label"
            SelectDisplayProps={{ style: { padding: 2 } }}
            id="select"
            value={patientPreferencesObject.initiallyOpen}
            onChange={handleChangeInitOpen}
            classes={{ icon: classes.dropDownIcon }}
          >
            <MenuItem value={0}>0</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={4}>4</MenuItem>
            <MenuItem value={5}>5</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={12} md={2}>
          <div className={classes.prefName}> History List position: </div>
          <Grid component="label" container alignItems="center" spacing={1}>
            <Grid item>top</Grid>
            <Grid item>
              <Switch
                checked={valueHistoryPosition}
                classes={{ track: classes.prefSwitch }}
                onChange={handleHistoryBarPositionChange}
                color="primary"
              />
            </Grid>
            <Grid item>bottom</Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={2}>
          <div className={classes.prefName}> Annotation colour: </div>
          {/*<FormControl className={classes.selectorItemFormControl}>*/}
            {/*<InputLabel className={classes.selectorItemLabel}>*/}
            {/*  {t("Color")}*/}
            {/*</InputLabel>*/}
            <Select
                renderValue={(value) => {
                  if(value["bg"] !== "transparent") {
                    return (
                        <div className={classes.colorPair} style={{ marginRight: 35}}>
                          <div className={classes.colorLeftWrap}>
                            <div className={classes.colorSelectedLabel}
                                 style={{
                                   color: value.bg,
                                 }}>Aa
                            </div>
                            <div
                                className={classes.colorLeftBox}
                                style={{backgroundColor: value.main}}
                            />
                          </div>

                          <div
                              className={classes.colorRightBox}
                              style={{backgroundColor: value.bg}}
                          />
                        </div>
                    )
                  }
                  return (
                      <div className={classes.colorOne} style={{backgroundColor: value.main}}></div>
                  );
                }}
                // variant="standard"
                value={annotationColor}
                onChange={handleChangeColor}
                // className={classes.selectorItemSelect}
                className={classes.dropDown}
                SelectDisplayProps={{style: {padding: 2, height: 41}}}
            >
              {config?.annotationsColor?.map((color) => {
                return (
                    <MenuItem value={color}>
                      <div
                          className={classes.colorOne}
                          style={{
                            backgroundColor: color['main'],
                            marginLeft: 0,
                            marginRight: 0,
                            width: '100%',
                          }}>
                      </div>
                    </MenuItem>
              );
              })}
              {
                config?.annotationsColorBg?.map((color) => {
                  return (
                      <MenuItem value={color}>

                        <div className={classes.colorLeftWrap}>
                          <div className={classes.colorLabel}
                               style={{
                                 color: color.bg,
                               }}>Aa
                          </div>
                          <div
                              className={classes.colorLeftBox}
                              style={{backgroundColor: color.main}}
                          />
                        </div>

                        <div
                            className={classes.colorRightBox}
                            style={{backgroundColor: color.bg}}
                        />
                      </MenuItem>
                  );
                })}
            </Select>
          {/*</FormControl>*/}
        </Grid>
        <Grid item xs={12} md={2}>
          <div className={classes.prefName}> Annotation Text Size:</div>
          <Select
              className={classes.dropDown}
              value={valueFontSize}
              SelectDisplayProps={{style: {padding: 2}}}
              onChange={handleChangeFontSize}
              classes={{icon: classes.dropDownIcon}}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={12}>12</MenuItem>
            <MenuItem value={14}>14</MenuItem>
            <MenuItem value={16}>16</MenuItem>
            <MenuItem value={18}>18</MenuItem>
            <MenuItem value={24}>24</MenuItem>
            <MenuItem value={36}>36</MenuItem>
            <MenuItem value={42}>42</MenuItem>
            <MenuItem value={48}>48</MenuItem>
            <MenuItem value={54}>54</MenuItem>
            <MenuItem value={58}>58</MenuItem>
            <MenuItem value={64}>64</MenuItem>
            <MenuItem value={68}>68</MenuItem>
            <MenuItem value={72}>72</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={12} md={2}>
          <div className={classes.prefName}> Multi-Frame Preload Mode: </div>
          <Select
            className={classes.dropDown}
            value={valueFramePreloadMode}
            SelectDisplayProps={{ style: { padding: 2 } }}
            onChange={handleChangeFramePreloadMode}
            classes={{ icon: classes.dropDownIcon }}
          >
            <MenuItem value={"none"}>{t("None")}</MenuItem>
            <MenuItem value={"background"}>{t("Background")}</MenuItem>
            {/*<MenuItem value={"block"}>{t("Screen-Freeze")}</MenuItem>*/}
            <MenuItem value={"smart"}>{t("Smart")}</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={12} md={2}>
          <div className={classes.prefName}> Holding Pen - default view: </div>
          <Grid component="label" container alignItems="center" spacing={1}>
            <Grid item>Focus Mode</Grid>
            <Grid item>
              <Switch
                  checked={valueHoldingPenViewList}
                  classes={{ track: classes.prefSwitch }}
                  onChange={handleHoldingPenViewChange}
                  color="primary"
              />
            </Grid>
            <Grid item>List Mode </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={4}>
          <div className={classes.prefName}> Holding Pen - summary view: </div>

          <Select
              className={classes.dropDown}
              labelId="label"
              SelectDisplayProps={{ style: { padding: 2 } }}
              id="select"
              value={patientPreferencesObject.bulkActionMode}
              onChange={handleBasketViewChange}
              classes={{ icon: classes.dropDownIcon }}
          >
            <MenuItem value={"hide"}>hidden</MenuItem>
            <MenuItem value={"show"}>enabled: document only on summary page</MenuItem>
            <MenuItem value={"showHide"}>enabled: duplicated documents</MenuItem>

          </Select>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.title}>{t("Patient Study filters")}</div>
        </Grid>

        <Grid item xs={12}>
          <div
            className={"scroll-normal-white"}
            style={{ minHeight: "300px", overflow: "auto" }}
          >
            <Grid
              container
              key={"aasas"}
              justifyContent={"center"}
              style={{ borderBottom: "1px solid #626466" }}
            >
              <Grid item>
                <span style={{ fontSize: 12 }}>Default</span>
                <Radio
                  checked={patientPreferencesObject.selectedFilterName === ""}
                  onClick={() => {
                    mainFilter("");
                  }}
                />
              </Grid>

              <Grid item xs={8}>
                <div
                  className={classes.filterName}
                  style={{
                    color:
                      patientPreferencesObject.selectedFilterName === ""
                        ? "#2180f7"
                        : "white",
                  }}
                >
                  No filters
                </div>
              </Grid>
              <Grid item width={90}></Grid>
            </Grid>
            {patientPreferencesObject.filtersList?.map((filters, index) => {
              return (
                <Grid
                  container
                  key={index + "aasas"}
                  justifyContent={"center"}
                  style={{
                    borderBottom: "1px solid #626466",
                    paddingBottom: 10,
                  }}
                >
                  <Grid item>
                    <span style={{ fontSize: 12 }}>Default</span>
                    <Radio
                      checked={
                        patientPreferencesObject.selectedFilterName ===
                        filters.name
                      }
                      onClick={() => {
                        mainFilter(filters.name);
                      }}
                    />
                  </Grid>

                  <Grid item xs={8}>
                    <div
                      className={classes.filterName}
                      style={{
                        color:
                          patientPreferencesObject.selectedFilterName ===
                          filters.name
                            ? "#2180f7"
                            : "white",
                      }}
                    >
                      View {filters.name}
                    </div>
                    <span className={classes.singleFilterName}>Sort by:</span>{" "}
                    <div className={classes.tag}>
                      {filters.sortStudy ? filters.sortStudy : "-"}{" "}
                    </div>
                    {filters.filters?.map((singleFilter) => (
                      <div style={{ marginTop: 5 }}>
                        {singleFilter.__filterValue && (
                          <div>
                            <span className={classes.singleFilterName}>
                              {" "}
                              {singleFilter.name}:{" "}
                            </span>
                            {singleFilter.type === "date" && (
                              <div className={classes.tag}>
                                {moment(singleFilter.__filterValue).format(
                                  config.defaultDateFormat,
                                )}
                              </div>
                            )}
                            {singleFilter.type !== "date" &&
                              singleFilter.__filterValue.map((f) => {
                                return <div className={classes.tag}>{f}</div>;
                              })}
                          </div>
                        )}
                      </div>
                    ))}
                  </Grid>

                  <Grid item>
                    <div
                      className={classes.deleteButton}
                      onClick={() => {
                        removeFilter(index);
                      }}
                    >
                      Delete
                    </div>
                  </Grid>
                </Grid>
              );
            })}

            {!patientPreferencesObject.filtersList && (
              <div style={{ padding: 12, borderBottom: "1px solid #dcd8d8" }}>
                no filters saved
              </div>
            )}
          </div>
        </Grid>

        {holdingPenSettings && (
          <React.Fragment>
            <Grid item xs={12}>
              <div className={classes.title}>{t("Holding Pen filters")}</div>
            </Grid>

            <Grid item xs={12}>
              {holdingPenDicts.map((fItem, index) => {
                let valueIsOnList = false;

                if (fItem.__filterValue) {
                  if (fItem.filter.hasOwnProperty("groupByField")) {
                    let splitName = fItem.__filterValue.split(" ");
                    if (fItem.dict[splitName[0]]) {
                      fItem.dict[splitName[0]].forEach((locationItem) => {
                        if (locationItem.__id === splitName[1]) {
                          valueIsOnList = true;
                        }
                      });
                    }
                  } else {
                    fItem.dict.forEach((locationItem) => {
                      if (
                        locationItem[
                          fItem.filter.displayField || "__description"
                        ] === fItem.__filterValue
                      ) {
                        valueIsOnList = true;
                      }
                    });
                  }
                }

                return (
                  <div
                    className={"scroll-normal-white"}
                    style={{ minHeight: 90, overflow: "auto" }}
                  >
                    <Grid
                      container
                      key={index + "hp_filter"}
                      justifyContent={"center"}
                      style={{
                        borderBottom: "1px solid #626466",
                        paddingBottom: 25,
                      }}
                    >
                      <Grid
                        item
                        xs={2}
                        style={{
                          textAlign: "right",
                          paddingRight: 30,
                          paddingTop: 8,
                        }}
                      >
                        <span style={{ fontSize: 12 }}>
                          {fItem.filter?.name}
                        </span>
                      </Grid>

                      <Grid item xs={8}>
                        <FormControl size={"small"} style={{ minWidth: 100 }}>
                          {/*<InputLabel shrink htmlFor="grouped-native-select">{fItem.filter.name}</InputLabel>*/}
                          <Select
                            onChange={(ev) => changeFilterValue(fItem, ev)}
                            size={"small"}
                            notched
                            renderValue={(val) => val}
                            value={fItem.__filterValue || ""}
                            MenuProps={{
                              classes: { paper: classes.menuPaper },
                            }}
                            id={"grouped-native-select_" + fItem.filter._id}
                          >
                            {!valueIsOnList && (
                              <MenuItem value={fItem.__filterValue}>
                                {fItem.__filterValue}
                              </MenuItem>
                            )}
                            {fItem.filter.customDictItems && (
                              <ListSubheader>Custom</ListSubheader>
                            )}
                            )
                            {fItem.filter.customDictItems &&
                              fItem.filter.customDictItems.map(
                                (customItemDict, index2) => {
                                  return (
                                    <MenuItem
                                      value={customItemDict.value}
                                      key={"dict_item_" + index2}
                                    >
                                      {customItemDict.display}
                                    </MenuItem>
                                  );
                                },
                              )}
                            {fItem.dict &&
                              fItem.filter.hasOwnProperty("groupByField") &&
                              Object.keys(fItem.dict).map((objKey, index3) => {
                                let items = [
                                  <ListSubheader key={"ls_" + index3}>
                                    {objKey}
                                  </ListSubheader>,
                                ];
                                fItem.dict[objKey].forEach((item) => {
                                  items.push(
                                    <MenuItem
                                      key={
                                        "mi_" +
                                        index3 +
                                        "_" +
                                        objKey +
                                        "_" +
                                        item[fItem.filter.displayField]
                                      }
                                      value={
                                        item[fItem.filter.groupByField] +
                                        " " +
                                        item[
                                          fItem.filter.displayField ||
                                            "__description"
                                        ]
                                      }
                                    >
                                      {
                                        item[
                                          fItem.filter.displayField ||
                                            "__description"
                                        ]
                                      }{" "}
                                    </MenuItem>,
                                  );
                                });

                                return items;
                              })}
                            {fItem.dict &&
                              !fItem.filter.hasOwnProperty("groupByField") &&
                              fItem.dict.map((dItem) => {
                                return (
                                  <MenuItem
                                    value={
                                      dItem[
                                        fItem.filter.displayField ||
                                          "__description"
                                      ]
                                    }
                                  >
                                    {
                                      dItem[
                                        fItem.filter.displayField ||
                                          "__description"
                                      ]
                                    }
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={2}>
                        <div
                          className={classes.deleteButton}
                          onClick={() => {
                            removeFilterValue(fItem);
                          }}
                        >
                          {t("Clear")}
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                );
              })}
            </Grid>
          </React.Fragment>
        )}
      </Grid>
    </div>
  );
}

export default PreferencesScreen;
